import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, allowedRoles }) {
    const auth = localStorage.getItem("auth");
    const tipo_usuario = localStorage.getItem("tipo_usuario");

    // Si no está autenticado, redirige al login
    if (!auth) {
        return <Navigate to="/login" />;
    }

    // Si el rol no está permitido, redirige al inicio
    if (allowedRoles && !allowedRoles.includes(tipo_usuario)) {
        return <Navigate to="/" />;
    }

    return children; // Si está autorizado y su rol está en allowedRoles, renderiza los hijos
}

export default ProtectedRoute;
